/* global axios */
import ApiClient from './ApiClient';

class AttributeAPI extends ApiClient {
  constructor() {
    super('custom_attribute_definitions', { accountScoped: true });
  }

  getAttributesByModel() {
    return axios.get(this.url);
  }

  // Lista valores possíveis (tipo `list`). Aceita query para typeahead quando
  // a definition tem api_searchable=true.
  listValues(attributeId, { q } = {}) {
    return axios.get(`${this.url}/${attributeId}/list_values`, {
      params: q ? { q } : {},
    });
  }

  // Valida um valor digitado contra a API externa configurada na definition.
  // Resposta: { valid, label?, error? }
  validateValue(attributeId, value) {
    return axios.get(`${this.url}/${attributeId}/validate_value`, {
      params: { value },
      validateStatus: status => status === 200 || status === 422,
    });
  }
}

export default new AttributeAPI();
